<script setup lang="ts">
import PhonesImage from '@features/apps/assets/phones.webp'
</script>

<template>
  <div class="apps-phones">
    <nuxt-img class="apps-phones__image" :src="PhonesImage" alt="PhonesImage" />
  </div>
</template>

<style scoped lang="scss">
.apps-phones {
  &__image {
    position: relative;
    width: 100%;
    max-height: 407px;
    overflow: unset;

    &:before {
      position: absolute;
      top: 10%;
      left: 53%;
      z-index: -1;
      width: 85%;
      height: 50%;
      content: '';
      background: var(--ui-color-supporting-01);
      border-radius: 397px;
      filter: blur(30px);
    }

    @include media($bp-tablet) {
      max-height: 505px;
    }
  }
}
</style>
